"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is the full page modal without the portal container. It can be deployed anywhere.
 */
var FullPageModalContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FullPageModalContent, _React$Component);

  function FullPageModalContent() {
    _classCallCheck(this, FullPageModalContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(FullPageModalContent).apply(this, arguments));
  }

  _createClass(FullPageModalContent, [{
    key: "getAnimation",

    /**
     * Gets a different animation depending on visible value.
     * @param {boolean} visible - visibility state of modal
     * @returns {string} name of animation
     */
    value: function getAnimation(visible) {
      var animation;

      if (!(0, _isUndefined2.default)(visible) && visible === true) {
        animation = 'swipe-up';
      } else if (!(0, _isUndefined2.default)(visible) && visible === false) {
        animation = 'swipe-down';
      } else {
        animation = '';
      }

      return animation;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          headerActions = _this$props.headerActions,
          onClose = _this$props.onClose,
          title = _this$props.title,
          visible = _this$props.visible,
          closeIconProps = _this$props.closeIconProps,
          props = _objectWithoutProperties(_this$props, ["children", "headerActions", "onClose", "title", "visible", "closeIconProps"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: "".concat(clsPrfx, "-full-page-modal-content ").concat(clsPrfx),
        "data-animation": this.getAnimation(visible)
      }, props), _react.default.createElement(_ModalHeader.default, {
        onClose: onClose,
        headerActions: headerActions,
        closeIconProps: closeIconProps,
        size: "large"
      }, title), _react.default.createElement("div", {
        className: "modal-body"
      }, children));
    }
  }]);

  return FullPageModalContent;
}(_react.default.Component);

exports.default = FullPageModalContent;